<script setup lang="ts">
withDefaults(
  defineProps<{
    variant: 'error' | 'neutral';
    title: string;
    description: string;
    tag?: string;
    titleClass?: string;
    descriptionClass?: string;
    innerClass?: string;
  }>(),
  {
    tag: 'h1',
    titleClass: '',
    descriptionClass: '',
    innerClass: '',
  },
);
</script>

<template>
  <section
    class="isolate flex min-h-96 w-full flex-col items-center justify-center gap-8 overflow-x-clip px-4 sm:min-h-120 sm:gap-16"
  >
    <div :class="cn('flex w-full flex-col items-center gap-4 sm:gap-8', innerClass)">
      <!-- exception: decorative circles must layer behind text -->
      <div class="relative -z-10 flex items-center justify-center">
        <span
          class="absolute h-12 w-12 rounded-full border opacity-100 sm:h-24 sm:w-24"
          :class="variant === 'error' ? 'border-red-200' : 'border-gray-200'"
        />
        <span
          class="absolute h-20 w-20 rounded-full border opacity-80 sm:h-40 sm:w-40"
          :class="variant === 'error' ? 'border-red-200' : 'border-gray-200'"
        />
        <span
          class="absolute h-28 w-28 rounded-full border opacity-60 sm:h-56 sm:w-56"
          :class="variant === 'error' ? 'border-red-200' : 'border-gray-200'"
        />
        <span
          class="absolute h-36 w-36 rounded-full border opacity-40 sm:h-72 sm:w-72"
          :class="variant === 'error' ? 'border-red-200' : 'border-gray-200'"
        />
        <span
          class="absolute h-44 w-44 rounded-full border opacity-30 sm:h-88 sm:w-88"
          :class="variant === 'error' ? 'border-red-200' : 'border-gray-200'"
        />
        <div
          class="relative flex max-h-10 min-h-10 min-w-10 max-w-10 items-center justify-center rounded-xl border bg-background sm:max-h-14 sm:min-h-14 sm:min-w-14 sm:max-w-14"
          :class="variant === 'error' ? 'border-red-200' : 'border-gray-200'"
        >
          <slot name="icon" />
        </div>
      </div>
      <component
        :is="tag"
        :class="cn('text-center text-3xl font-semibold sm:text-5xl', titleClass)"
      >
        {{ title }}
      </component>
      <p :class="cn('max-w-lg text-center text-lg font-normal text-gray-600 sm:text-xl', descriptionClass)">
        {{ description }}
      </p>
    </div>
    <slot />
  </section>
</template>
